module.exports = __webpack_public_path__ + "img/amazon-circle.ee5eea74.svg";